import DomainEntity from '@/models/DomainEntity'

export default class StrategyStaff extends DomainEntity {
  static get collectionName() {
    return 'strategystaff/'
  }

  static get parentKey() {
    return 'strategy'
  }

  static defaults() {
    return {
      hire: [],
      update: {},
      fire: [],
      needNewStaff: true,
    }
  }
}
